import { Trans, t } from '@lingui/macro';
import { ConfirmDialog, Typography } from '@pocketlaw/tetris';
import { useRemoveApiKey } from 'app/domains/api-management';
export function RemoveKeyDialog(props) {
    const { onClose, id } = props;
    const { removeApiKey, loading } = useRemoveApiKey();
    return (<ConfirmDialog appearance="danger" loading={loading} heading={t({ message: 'Delete key', comment: 'Key Table delete key dialog - title' })} onCancel={onClose} cancel={t({
            message: 'Cancel',
            comment: 'Key Table delete key dialog cancel button - Cancel',
        })} onConfirm={() => removeApiKey(id)} confirm={t({
            message: 'Delete',
            comment: 'Key Table delete key dialog confirm button- Delete key',
        })}>
      <Typography>
        <Trans comment="Key Table delete key dialog - message">
          Are you sure you want to delete this key? This key will be permanently deleted and can not
          be recovered.
        </Trans>
      </Typography>
    </ConfirmDialog>);
}
